export default __webpack_public_path__ + "static/media/referral.5a6c4073.svg";